export const TRACK_LOGIN_STORAGE_KEY = 'webshop_track-initial-login';
export const TRACK_SIGN_UP_STORAGE_KEY = 'webshop_track_sign_up';
export const TRACK_ORDER_PENDING_STORAGE_KEY = 'webshop_track_order_pending';
export const TRACK_SHIPPING_NAME_STORAGE_KEY = 'webshop_track_shipping_name';
export const TRACK_GATEWAY_PAYMENT_STORAGE_KEY = 'webshop_track_gateway_payment';
export const TRACK_EMAIL_PROMO_SESSION_KEY = 'webshop_track_email_promo';
export const TRACK_REAL_LIST_VALUE = 'real_list';
